import { useSheetContext } from "@/context/sheet";
import { useCreateGuide } from "@/hooks/guides";
import { CreateGuide } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(guides)/guides/_sheet/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutateAsync } = useCreateGuide({
    onSuccess: (guide) => {
      close(() => {
        navigate({
          to: "/guides",
          params: { id: guide.id.toString() },
        });
      });
    },
  });

  const create = async (guide: CreateGuide) => {
    await mutateAsync(guide);
  };

  return <Form onUpsert={create} />;
}
